import React from "react";
import GoogleFontLoader from "react-google-font-loader";
import Hidden from "@material-ui/core/Hidden";

export default function HeaderText() {
  return (
    <>
      <GoogleFontLoader
        fonts={[
          {
            font: "Josefin Slab",
            weights: [700, "400i"],
            size: "2rem"
          },
          {
            font: "Josefin Slab",
            weights: [400, 700],
            fontSize: "40px"
          }
        ]}
        subsets={["cyrillic-ext", "greek"]}
      />
      <Hidden smDown>
        <span
          style={{ fontFamily: "Josefin Slab, monospaced", fontSize: "2vw" }}
        >
          {" "}
          <strong>Karan More</strong> | software developer
        </span>
      </Hidden>
      <Hidden smUp>
        <span
          style={{ fontFamily: "Josefin Slab, monospaced", fontSize: "5vw" }}
        >
          {" "}
          <strong>Karan More</strong> | software developer
        </span>
      </Hidden>
    </>
  );
}
